module.exports = __webpack_public_path__ + "img/vaciar-busqueda.2c5552a1.svg";